import { gql } from '@apollo/client';
import { CORE_PAGE_INFO_FIELDS } from 'src/components/providers/apollo-provider-provider';

export const AI_AGENTS_LIST_QUERY = gql`
  ${CORE_PAGE_INFO_FIELDS}
  query AIAgentsList(
    $companyId: Int!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $orderBy: AIAgentOrderByInput
  ) {
    aiAgents {
      listAIAgents(
        companyId: $companyId
        after: $after
        before: $before
        first: $first
        last: $last
        orderBy: $orderBy
      ) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        nodes {
          id
          name
          typeName
          createdBy {
            id
            fullName
            avatar {
              color
              initials
              url(transform: { width: 180, height: 180 })
            }
            role {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const AI_AGENT_DETAIL_QUERY = gql`
  query AIAgentDetail($input: AIAgentInput!) {
    aiAgents {
      getAIAgent(input: $input) {
        id
        name
        privateKnowledgeBase {
          id
        }
      }
    }
  }
`;
